module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray-3ccb70d388d663045077a5d6714fcd63.png";